import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api/client";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ll_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/admin/me")
      .then((r) => setUser({ username: r.data.username }))
      .catch(() => localStorage.removeItem("ll_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await api.post("/admin/login", { username, password });
    localStorage.setItem("ll_admin_token", res.data.token);
    setUser({ username: res.data.username });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("ll_admin_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
